import React, { memo, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Bleed, Tag, Ellipsis, Row, H2, Overline, Separator, colors, usePageWidth, Paragraph } from '@fs/zion-ui'
import { ArrowCaret } from '@fs/zion-icon'
import { GroupImage } from '@fs/zion-group-management'
import { useShowTemple } from '@fs/zion-permissions'
import { useGroupsContext } from '@fs/zion-tree-groups'

function GroupCardContents({ group }) {
  const [t] = useTranslation()
  const [showTemple] = useShowTemple()
  const { canAccessFGT } = useGroupsContext()
  const atWidth = usePageWidth()
  const isNano = atWidth({ default: true, xxs: false })
  const Component = useMemo(
    () =>
      group.isProcessing
        ? 'div'
        : ({ children }) => (
            <Bleed top={!isNano} start={!isNano} bottom={!isNano}>
              {children}
            </Bleed>
          ),
    [group.isProcessing, isNano]
  )

  return (
    <Component>
      <Row alignY="middle">
        {!group.isProcessing && !isNano && <GroupImage group={group} inGroupList noShrinkX />}
        <div growX>
          <H2 size="H6" supplementary>
            {group.memberCount > 0 && (
              <Overline>{t('group-management.members-count.heading', { memberCount: group.memberCount })}</Overline>
            )}
            <Ellipsis data-testid={`group-title-${group.name}`} lineClamp={2}>
              {group.name}
            </Ellipsis>
          </H2>
          <Separator size="nano" />
          <Row gutters="nano">
            {group.types.includes('ORDINANCE_SHARING') && showTemple && (
              <Tag color="green" text={t('group-management.group-type-ordinances.label')} />
            )}
            {group.types.includes('PRIVATE_PERSON_SHARING') && canAccessFGT && (
              <Tag text={t('group-management.group-type-tree.label')} />
            )}
          </Row>
          {group.isProcessing && (
            <Paragraph size="sm">
              {t('group-management.gedcom-in-progress.heading', {
                groupName: group.file?.fileName || group.name,
              })}
            </Paragraph>
          )}
        </div>
        {group.id && (
          <div>
            <ArrowCaret color={colors.blue60} />
          </div>
        )}
      </Row>
    </Component>
  )
}

export default memo(GroupCardContents)
